// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-page {
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  h2 {
    text-align: center;
  }
  
  .calendar-grid {
    display: flex;
    justify-content: space-around;
  }
  
  .day-column {
    flex: 1 1;
    margin: 0 10px;
    background-color: #f3f3f3;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  h3 {
    text-align: center;
    margin-top: 0;
  }
  
  .meal-slot {
    margin: 10px 0;
  }
  
  label {
    font-weight: bold;
    display: block;
    margin-bottom: 5px;
  }
  
  input[type="text"] {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .rbc-time-header-gutter {
    display: none;
  }
  
  .rbc-time-content > * + * > * {
    border-left: none;
  }

  .rbc-event {
    border: none !important;
    background-color: transparent !important;
    padding: 0 !important;
  }

  .rbc-day-slot .rbc-background-event {
    background: linear-gradient(120deg, rgba(59, 130, 246, 0.12), rgba(59, 130, 246, 0.03)) !important;
    border: 1px solid rgba(59, 130, 246, 0.25) !important;
    border-radius: 8px !important;
  }

  /* Hide time column in agenda view */
  .rbc-agenda-view .rbc-agenda-time-cell,
  .rbc-agenda-view .rbc-agenda-time-column {
    display: none !important;
  }

.rbc-agenda-view .rbc-agenda-table thead > tr > th:nth-child(2) {
  display: none !important;
}

  .rbc-agenda-view table thead > tr > th:first-child,
  .rbc-agenda-view .rbc-agenda-date-cell {
    padding-left: 16px;
  }

.calendar-event-card {
    width: 100%;
    height: 20px;
    border-radius: 8px;
    padding: 4px 6px;
    color: #0f172a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15);
    transition: box-shadow 0.2s ease;
  }

  .calendar-event-card:hover {
    box-shadow: 0 4px 8px rgba(15, 23, 42, 0.25);
  }

  .calendar-remove-dish-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.1);
    color: #0f172a;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .calendar-remove-dish-btn:hover {
    background: rgba(239, 68, 68, 0.2);
    color: #b91c1c;
  }

  .calendar-event-title {
    font-size: 0.85rem;
    font-weight: 700;
  }

  .calendar-event-dish {
    font-size: 0.75rem;
    font-weight: 600;
    opacity: 0.85;
    text-align: right;
    flex-shrink: 0;
  }

  .calendar-event--blue {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05));
    border-color: rgba(59, 130, 246, 0.4);
  }

  .calendar-event--green {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.18), rgba(16, 185, 129, 0.05));
    border-color: rgba(16, 185, 129, 0.35);
  }

  .calendar-event--purple {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.18), rgba(139, 92, 246, 0.05));
    border-color: rgba(139, 92, 246, 0.35);
  }

  .calendar-event--pink {
    background: linear-gradient(135deg, rgba(236, 72, 153, 0.2), rgba(236, 72, 153, 0.07));
    border-color: rgba(236, 72, 153, 0.4);
  }

  .calendar-event--orange {
    background: linear-gradient(135deg, rgba(249, 115, 22, 0.22), rgba(249, 115, 22, 0.08));
    border-color: rgba(249, 115, 22, 0.4);
  }
  /* Hide the hour gutter and the time grid */
.rbc-time-view .rbc-time-gutter,
.rbc-time-view .rbc-time-content {
  display: none !important;
}

Expand the all-day row so it fills the available height
.rbc-time-view .rbc-allday-cell {
  height: auto !important;
  min-height: 400px; /* adjust to whatever height you want */
}

/* Remove the extra separator row when the time grid is hidden */
.rbc-time-view .rbc-allday-cell + .rbc-row {
  display: none !important;
}
.rbc-calendar {
  flex: 1 1;
  min-height: 1000px;
}`, "",{"version":3,"sources":["webpack://./src/styles/CalendarPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,SAAO;IACP,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,qBAAqB;EACvB;;EAEA;IACE,kGAAkG;IAClG,qDAAqD;IACrD,6BAA6B;EAC/B;;EAEA,oCAAoC;EACpC;;IAEE,wBAAwB;EAC1B;;AAEF;EACE,wBAAwB;AAC1B;;EAEE;;IAEE,kBAAkB;EACpB;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,6BAA6B;IAC7B,4CAA4C;IAC5C,gCAAgC;EAClC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,uFAAuF;IACvF,qCAAqC;EACvC;;EAEA;IACE,uFAAuF;IACvF,sCAAsC;EACxC;;EAEA;IACE,uFAAuF;IACvF,sCAAsC;EACxC;;EAEA;IACE,sFAAsF;IACtF,qCAAqC;EACvC;;EAEA;IACE,uFAAuF;IACvF,qCAAqC;EACvC;EACA,2CAA2C;AAC7C;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA,gEAAgE;AAChE;EACE,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,kBAAkB;AACpB","sourcesContent":[".calendar-page {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  h2 {\n    text-align: center;\n  }\n  \n  .calendar-grid {\n    display: flex;\n    justify-content: space-around;\n  }\n  \n  .day-column {\n    flex: 1;\n    margin: 0 10px;\n    background-color: #f3f3f3;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  h3 {\n    text-align: center;\n    margin-top: 0;\n  }\n  \n  .meal-slot {\n    margin: 10px 0;\n  }\n  \n  label {\n    font-weight: bold;\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  input[type=\"text\"] {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n\n  .rbc-time-header-gutter {\n    display: none;\n  }\n  \n  .rbc-time-content > * + * > * {\n    border-left: none;\n  }\n\n  .rbc-event {\n    border: none !important;\n    background-color: transparent !important;\n    padding: 0 !important;\n  }\n\n  .rbc-day-slot .rbc-background-event {\n    background: linear-gradient(120deg, rgba(59, 130, 246, 0.12), rgba(59, 130, 246, 0.03)) !important;\n    border: 1px solid rgba(59, 130, 246, 0.25) !important;\n    border-radius: 8px !important;\n  }\n\n  /* Hide time column in agenda view */\n  .rbc-agenda-view .rbc-agenda-time-cell,\n  .rbc-agenda-view .rbc-agenda-time-column {\n    display: none !important;\n  }\n\n.rbc-agenda-view .rbc-agenda-table thead > tr > th:nth-child(2) {\n  display: none !important;\n}\n\n  .rbc-agenda-view table thead > tr > th:first-child,\n  .rbc-agenda-view .rbc-agenda-date-cell {\n    padding-left: 16px;\n  }\n\n.calendar-event-card {\n    width: 100%;\n    height: 20px;\n    border-radius: 8px;\n    padding: 4px 6px;\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n    border: 1px solid transparent;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15);\n    transition: box-shadow 0.2s ease;\n  }\n\n  .calendar-event-card:hover {\n    box-shadow: 0 4px 8px rgba(15, 23, 42, 0.25);\n  }\n\n  .calendar-remove-dish-btn {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: rgba(15, 23, 42, 0.1);\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    cursor: pointer;\n    transition: background 0.2s ease;\n  }\n\n  .calendar-remove-dish-btn:hover {\n    background: rgba(239, 68, 68, 0.2);\n    color: #b91c1c;\n  }\n\n  .calendar-event-title {\n    font-size: 0.85rem;\n    font-weight: 700;\n  }\n\n  .calendar-event-dish {\n    font-size: 0.75rem;\n    font-weight: 600;\n    opacity: 0.85;\n    text-align: right;\n    flex-shrink: 0;\n  }\n\n  .calendar-event--blue {\n    background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05));\n    border-color: rgba(59, 130, 246, 0.4);\n  }\n\n  .calendar-event--green {\n    background: linear-gradient(135deg, rgba(16, 185, 129, 0.18), rgba(16, 185, 129, 0.05));\n    border-color: rgba(16, 185, 129, 0.35);\n  }\n\n  .calendar-event--purple {\n    background: linear-gradient(135deg, rgba(139, 92, 246, 0.18), rgba(139, 92, 246, 0.05));\n    border-color: rgba(139, 92, 246, 0.35);\n  }\n\n  .calendar-event--pink {\n    background: linear-gradient(135deg, rgba(236, 72, 153, 0.2), rgba(236, 72, 153, 0.07));\n    border-color: rgba(236, 72, 153, 0.4);\n  }\n\n  .calendar-event--orange {\n    background: linear-gradient(135deg, rgba(249, 115, 22, 0.22), rgba(249, 115, 22, 0.08));\n    border-color: rgba(249, 115, 22, 0.4);\n  }\n  /* Hide the hour gutter and the time grid */\n.rbc-time-view .rbc-time-gutter,\n.rbc-time-view .rbc-time-content {\n  display: none !important;\n}\n\nExpand the all-day row so it fills the available height\n.rbc-time-view .rbc-allday-cell {\n  height: auto !important;\n  min-height: 400px; /* adjust to whatever height you want */\n}\n\n/* Remove the extra separator row when the time grid is hidden */\n.rbc-time-view .rbc-allday-cell + .rbc-row {\n  display: none !important;\n}\n.rbc-calendar {\n  flex: 1;\n  min-height: 1000px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
